import { render } from "./PreviewArea.vue?vue&type=template&id=5714f133&scoped=true"
import script from "./PreviewArea.vue?vue&type=script&lang=js"
export * from "./PreviewArea.vue?vue&type=script&lang=js"

import "./PreviewArea.vue?vue&type=style&index=0&id=5714f133&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5714f133"]])

export default __exports__